import React, { ReactNode, useEffect, useState } from 'react'
import Tabs from '../Tabs'
import { LVType } from '../../../utils/schema/CommonSchema'
import FullScreenLoader from '../FullScreenLoader'

type TabType = LVType & {
  component: ReactNode
}
type Props = {
  tabs: TabType[]
  defaultTabIndex?: number
  wrapperClass?: string
  bodyClass?: string
  handleClick?: any
}

const CustomTabs = (props: Props) => {
  const { tabs, defaultTabIndex, wrapperClass, bodyClass, handleClick } = props
  const [currentTab, setCurrentTab] = useState(
    tabs && tabs.length > 0 ? tabs[defaultTabIndex ?? 0] : null
  )

  // Only run on mount (empty dependency array), like previous implementation,
  // so currentTab is set initially and not overwritten every parent render.
  useEffect(() => {
    if (
      tabs?.length > 0 &&
      defaultTabIndex !== undefined &&
      defaultTabIndex >= 0 &&
      tabs[defaultTabIndex]
    ) {
      setCurrentTab(tabs[defaultTabIndex])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // intentionally ignore tabs and defaultTabIndex

  const handleTabChange = (e: any) => {
    if (handleClick) {
      handleClick(e?.value)
    }
    setCurrentTab(e)
  }

  return (
    <div className={`${wrapperClass}`}>
      {tabs && tabs.length > 0 ? (
        <React.Fragment>
          {currentTab && (
            <Tabs list={tabs} currentTab={currentTab || []} onClick={handleTabChange} />
          )}
          <div className={` ${bodyClass || ''}`}>
            {tabs?.map((tab: TabType, key: number) => (
              <React.Fragment key={key}>
                {currentTab?.value === tab?.value && tab?.component}
              </React.Fragment>
            ))}
          </div>
        </React.Fragment>
      ) : (
        <FullScreenLoader />
      )}
    </div>
  )
}

export default CustomTabs
